// components/SEOHelmet.jsx
import React from "react";
import { Helmet } from "react-helmet-async";

const SEOHelmet = ({
  title = "آدین زون | Adinzone",
  description = "به آدین زون خوش آمدید. پلتفرم تخصصی برای ارائه بهترین خدمات و راهکارها.",
  keywords = "آدین زون, adinzone, خدمات آنلاین, پلتفرم آدین زون",
  author = "Adinzone",
  ogTitle,
  ogDescription,
  ogImage = "/media/global/adinZoneLow.jpeg",
  ogUrl,
  canonicalUrl,
}) => {
  // جلوگیری از خطای SSR در صورت عدم دسترسی به شیء window
  const currentUrl = ogUrl || canonicalUrl || "https://adinzone.ir";

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{title}</title>
      <meta name="title" content={title} />
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="author" content={author} />
      {/* Canonical URL برای سئو بسیار مهم است */}
      {canonicalUrl && <link rel="canonical" href={canonicalUrl} />}

      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={currentUrl} />
      <meta property="og:title" content={ogTitle || title} />
      <meta property="og:description" content={ogDescription || description} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:site_name" content="Adinzone" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={currentUrl} />
      <meta name="twitter:title" content={ogTitle || title} />
      <meta name="twitter:description" content={ogDescription || description} />
      <meta name="twitter:image" content={ogImage} />
    </Helmet>
  );
};

export default SEOHelmet;
